import React, { Component } from 'react';
import GoogleLogin from 'react-google-login';
import API from './API';
import App from './App';

class PageLogin extends Component {
    responseGoogle(WE){
        var me = this;
        console.log("WE");
        console.log(WE)
        API.idToken = WE.tokenObj.id_token;
        API.callAPI('App.login', undefined, function(resp){
          API.idToken = resp.data.session.Idtoken;
          App.webUser = resp.data.webUser;
          App.session = resp.data.session;
          me.props.onLogin();
        }, function(b){
          me.forceUpdate();
        });
        // secret: 72WOLNL-_AGFs47wJ7m15tQY
    }
    
    render(){
        var me = this;
        return(
            <div className="center">
            <GoogleLogin
            className="center-in"
            clientId="36660943342-cvf9qsrgo0h3fie2tcemn5a500p1qqn1.apps.googleusercontent.com"
            buttonText="Belépés Google azonosítóval"
            onSuccess={me.responseGoogle.bind(me)}
            onFailure={me.responseGoogle.bind(me)}
            />
            </div>
        )
    }
}

export default PageLogin;